export default { sha: '293b67eab2d14fbf8f4371e47f25133232bd1920', buildNumber: 'undefined' }
